import React, { useEffect, useState } from "react";

import IconVerified from "../../../assets/verified.svg";
import IconCross from "../../../assets/no-stopping.png";

export default function Table({requirement}) {
  return (
    <div
      style={{
        backgroundColor: "white",
        marginBottom: 90,
      }}
    >
      <div className="container table-responsive">
        <table style={{width: '100%', minWidth: '820px'}}>
        <div className="row">
          <div
            className="col-1"
            style={{ backgroundColor: "#F5F5F5", padding: "16px 12px" }}
          >
            <p
              style={{ marginBottom: 0, fontWeight: "bold" }}
              className="p-nunito"
            >
              Nomor
            </p>
          </div>
          <div
            className="col-7"
            style={{ backgroundColor: "#1672BD", padding: "16px 12px" }}
          >
            <p
              className="p-nunito"
              style={{ marginBottom: 0, fontWeight: "bold", color: "white" }}
            >
              Persyaratan PSrE
            </p>
          </div>
          <div
            className="col-2"
            style={{ backgroundColor: "#F5F5F5", padding: "16px 12px" }}
          >
            <p
              className="p-nunito"
              style={{
                marginBottom: 0,
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              PSrE Instansi
            </p>
          </div>
          <div
            className="col-2"
            style={{ backgroundColor: "#E5E5E5", padding: "16px 12px" }}
          >
            <p
              style={{
                marginBottom: 0,
                fontWeight: "bold",
                textAlign: "center",
              }}
              className="p-nunito"
            >
              PSrE Non Instansi
            </p>
          </div>
        </div>
        <div>
          {requirement.map((value,idx) => (
            <div className="row" style={{ borderBottom: "1px solid #E5E5E5", flexWrap: 'nowrap' }} key={idx}>
              <div
                className="col-1"
                style={{
                  backgroundColor: "white",
                  padding: "16px 12px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 30,
                    width: 30,
                    backgroundColor: "#EDF1F5",
                    borderRadius: 5,
                  }}
                >
                  <p
                    style={{
                      marginBottom: 0,
                    }}
                    className="p-nunito"
                  >
                    {idx + 1}
                  </p>
                </div>
              </div>
              <div
                className="col-7"
                style={{
                  backgroundColor: "white",
                  padding: "16px 12px",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <p
                  className="p-nunito"
                  style={{
                    marginBottom: 0,
                    color: "black",
                  }}
                >
                  {value.requirementName}
                </p>
              </div>
              <div
                className="col-2"
                style={{
                  backgroundColor: "white",
                  padding: "16px 12px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {value.isInstitute ? (
                  <img
                    className="mb-0"
                    src={IconVerified}
                    alt="icon-verified"
                    style={{ width: "17px", objectFit: "contain" }}
                  />
                ) : <img
                className="mb-0"
                src={IconCross}
                alt="icon-cross"
                style={{ width: "13px", objectFit: "contain" }}
              />}
              </div>
              <div
                className="col-2"
                style={{
                  backgroundColor: "white",
                  padding: "16px 12px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {value.isNonInstitute ? (
                  <img
                    className="mb-0"
                    src={IconVerified}
                    alt="icon-verified"
                    style={{
                      width: "17px",
                      objectFit: "contain",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  />
                ) : <img
                className="mb-0"
                src={IconCross}
                alt="icon-cross"
                style={{ width: "13px", objectFit: "contain" }}
              />}
              </div>
            </div>
          ))}
        </div>
        </table>
      </div>
    </div>
  );
}
